/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { APPLICATION_STATUS_DESCRIPTION, APPLICATION_STATUS_DOCUMENTS, APPLICATION_STATUS_PERSONAL } from "@/src/services/familyLaw/applicationStatus";
import React from "react";
import ProgressBar from "@/src/components/ProgressBar/ProgressBar";
import progressBarsteps from "./progressBarSteps";
import familyLawFormSteps from "@/src/services/familyLaw/formSteps";
import PersonalTextMessage from "@/src/components/Form/Common/PersonalTextMessage/PersonalTextMessage";
import Documents from "@/src/components/Form/Common/Documents/Documents";
import Personal from "@/src/components/Form/Common/Personal/Personal";
import { FormSteps } from "@/src/types/FormServiceBase";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_DESCRIPTION]: {
    ...familyLawFormSteps[APPLICATION_STATUS_DESCRIPTION],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"description"} progress={15} />
        <PersonalTextMessage {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    ...familyLawFormSteps[APPLICATION_STATUS_DOCUMENTS],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={50} />
        <Documents {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_PERSONAL]: {
    ...familyLawFormSteps[APPLICATION_STATUS_PERSONAL],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={83} />
        <Personal {...props} personPath={"client.person"} />
      </>
    ),
  },
};

export default formSteps;
